@if (eventSystem$ | async; as eventSystem) {
    <app-event-system-headline [system]="eventSystem" />
    @if (events$ | async; as events){
        <app-events-summary-list [eventList]="events" />
    }
}

